import type { TableQuery } from 'ab-common/dataStructures/tableQuery';

import baseRoute from '../baseRoute';

export type * from './viewModel';
export type * from './queryParams';

type RouteDefinition = `${typeof baseRoute}/table${`?query=${string}&startDate=${string}&endDate=${string}&timezone=${string}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/table`;

export const URL = (startDate: string, endDate: string, timezone: string, tableQuery: TableQuery): RouteDefinition =>
	`${baseRoute}/table?query=${encodeURIComponent((JSON.stringify(tableQuery)))}&startDate=${startDate}&endDate=${endDate}&timezone=${timezone}`;
